import type { LocationFilterKey } from '@/lib/api/types/itemFilters';

export const LOCATION_PICKLIST_FILTERS = [
  'holidaySchemeId',
] as const satisfies readonly LocationFilterKey[];

export const LOCATION_BOOLEAN_FILTERS = [
  'showArchivedLocations',
] as const satisfies readonly LocationFilterKey[];

export const LOCATION_FILTER_KEYS = [
  ...LOCATION_PICKLIST_FILTERS,
  ...LOCATION_BOOLEAN_FILTERS,
] as const satisfies readonly LocationFilterKey[];

export const getLocationTableFilters = () => [...LOCATION_FILTER_KEYS] as const;
